module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-dark-on-white-11fb71a27798cd6a5ae420085db7ec7b.svg";